"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("lodash/bind"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ssrWindow = require("ssr-window");

var _checkCircle = _interopRequireDefault(require("@spothero/icons/check-circle"));

var _exclamationCircle = _interopRequireDefault(require("@spothero/icons/exclamation-circle"));

var _exclamationTriangle = _interopRequireDefault(require("@spothero/icons/exclamation-triangle"));

var _heroCar = _interopRequireDefault(require("@spothero/icons/hero-car"));

var _times = _interopRequireDefault(require("@spothero/icons/times"));

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _NotificationPropTypes = _interopRequireDefault(require("./NotificationPropTypes"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var Notification = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Notification, _Component);

  var _super = _createSuper(Notification);

  function Notification(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Notification);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onHideClick", function (evt) {
      _this._hide();
    });
    var duration = props.duration,
        autoClose = props.autoClose;

    if (autoClose) {
      _this._hideTimeout = _ssrWindow.window.setTimeout((0, _bind.default)(_this._hide, (0, _assertThisInitialized2.default)(_this)), duration);
    }

    return _this;
  }

  (0, _createClass2.default)(Notification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _ssrWindow.window.setTimeout(function () {
        _dom.default.addClass(_this2._notification, 'Notification-showing');
      }, 100);
    }
  }, {
    key: "_hide",
    value: function _hide() {
      var _this3 = this;

      var _this$props = this.props,
          onHidden = _this$props.onHidden,
          onRemove = _this$props.onRemove;

      if (this._hideTimeout) {
        _ssrWindow.window.clearTimeout(this._hideTimeout);
      }

      _dom.default.removeClass(this._notification, 'Notification-showing');

      _ssrWindow.window.setTimeout(function () {
        _dom.default.removeClass(_this3._notification, 'Notification-showing');

        if (onHidden) {
          onHidden(_this3.props);
        }

        onRemove();
      }, 500);
    }
  }, {
    key: "_renderIcon",
    value: function _renderIcon() {
      var type = this.props.type;

      switch (type) {
        default:
        case 'info':
          return /*#__PURE__*/_react.default.createElement(_heroCar.default, null);

        case 'success':
          return /*#__PURE__*/_react.default.createElement(_checkCircle.default, null);

        case 'warning':
          return /*#__PURE__*/_react.default.createElement(_exclamationTriangle.default, null);

        case 'error':
          return /*#__PURE__*/_react.default.createElement(_exclamationCircle.default, null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          type = _this$props2.type,
          message = _this$props2.message,
          showClose = _this$props2.showClose;
      var classes = (0, _classnames.default)('Notification', "Notification-".concat(type), className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes,
        ref: function ref(node) {
          _this4._notification = node;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "Notification-content-container container"
      }, this._renderIcon(), /*#__PURE__*/_react.default.createElement("div", {
        className: "Notification-content"
      }, message), showClose && /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "Notification-hide",
        onClick: this._onHideClick
      }, /*#__PURE__*/_react.default.createElement(_times.default, {
        className: "Icon-cancel"
      }))));
    }
  }]);
  return Notification;
}(_react.Component);

exports.default = Notification;
(0, _defineProperty2.default)(Notification, "defaultProps", {
  type: 'info',
  duration: 3000,
  showClose: true,
  autoClose: true
});